import type { FC } from 'react';
import React from 'react';

import './App.scss';
import RentForm from './forms/rent/RentForm';
import ServiceForm from './forms/service/ServiceForm';
import VosForm from './forms/vos/VosForm';

type TFormType = 'abhol' | 'vos' | 'rent';

interface IAppProps {
  // eslint-disable-next-line
  domElement: any;
}

// Fallback, falls PHP kein data-form am #root setzt: Formular am URL-Pfad wählen.
const formFromPath = (): TFormType => {
  const path = window.location.pathname;

  if (path.startsWith('/vos') || path.startsWith('/vor-ort-service')) {
    return 'vos';
  }

  if (path.startsWith('/rent') || path.startsWith('/vermietung')) {
    return 'rent';
  }

  return 'abhol';
};

const App: FC<IAppProps> = ({
  domElement
}) => {
  if (window.location.pathname === '/sentry-test') {
    return (
      <button onClick={() => {
        throw new Error('Sentry Test Error');
      }}>Test Sentry</button>
    );
  }

  const form: TFormType = domElement?.dataset?.form || formFromPath();

  switch (form) {
    case 'vos':
      return <VosForm domElement={domElement} />;
    case 'rent':
      return <RentForm />;
    default:
      return <ServiceForm />;
  }
};

export default App;
